module.exports = __webpack_public_path__ + "static/media/404.72236585.png";